import React, { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';


import { getQuarters } from '../../utils/constCodeUtils';

const HeadquartersQuarterGoalTable = ({ rows, handleSelectedRow , selectedRow}) => {
  const [quarters, setQuarters] = useState([])
  useEffect(() => {
    const arrQuarter = getQuarters();
    setQuarters(arrQuarter);
  }, [])


  return (
    <Box sx={{ width: '100%' }}>
      <Paper sx={{ width: '100%', mb: 2 }}>
        <TableContainer>
          <Table sx={{ minWidth: 750 }} aria-label="headquarter year goal table">
            <TableHead>
              <TableRow>
                <TableCell><Typography variant="subtitle2" component="div">본부명</Typography></TableCell>
                {quarters && quarters.map((quarter) => (
                  <TableCell key={quarter} align="center">
                    <Typography variant="subtitle2"component="div">{quarter} 분기</Typography>
                    <Typography variant="body2"component="div">(목표/실적)</Typography>
                    </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody >
              {rows && rows.map((row, index) => (
                <TableRow
                hover
                  key={row.id}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  onClick={()=>handleSelectedRow(row)}
                  selected={selectedRow?.id === row.id}
                >
                  <TableCell component="th" scope="row">
                  <Typography variant="subtitle2"component="div">{row?.dptNm}</Typography>
                  </TableCell>
                  {quarters && quarters.map((quarter,index) => (
                    <TableCell key={`${row.id}_${quarter}`} align="center">
                      <Typography variant="body2"component="span" color="text.secondary">
                      {row.goals[index][quarter]}
                      </Typography>
                      <Typography variant="body2"component="span" sx={{mx:0.1}}>/</Typography>
                      <Typography variant="subtitle2"component="span" color={(row.goals[index][quarter] > row.results[index][quarter])?'error.main':'success.main'}>
                      {row.results[index][quarter]}
                      </Typography>
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>

  )
}

export default HeadquartersQuarterGoalTable